/**
 * Dashboard Routes
 */

import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { ProtectedRoute } from "@/components/layout/protected-route";
import { DashboardPage } from "./pages/dashboard";
import { ExploreProjectPreviewPage } from "./pages/explore-project-preview";
import { ExplorePublicPage } from "./pages/explore-public";
import { HomeDashboard } from "./pages/homeowner-dashboard";
import { HomeownerInspirePage } from "./pages/homeowner-inspire";

export const dashboardRoutes: RouteObject[] = [
	{
		path: "/public-projects",
		element: <ExplorePublicPage />,
	},
	{
		path: "/public-projects/:id",
		element: <ExploreProjectPreviewPage />,
	},
	{
		path: "/explore",
		element: <Navigate to="/public-projects" replace />,
	},
	{
		path: "/explore/projects/:id",
		element: <ExploreProjectPreviewPage />,
	},
	{
		path: "/home",
		element: (
			<ProtectedRoute requireUserType="homeowner">
				<HomeDashboard />
			</ProtectedRoute>
		),
	},
	{
		path: "/inspire",
		element: (
			<ProtectedRoute requireUserType="homeowner">
				<HomeownerInspirePage />
			</ProtectedRoute>
		),
	},
	{
		path: "/dashboard",
		element: (
			<ProtectedRoute requireUserType>
				<DashboardPage />
			</ProtectedRoute>
		),
	},
];
